export const GoodsFormOption = {
  align: "center",
  menuAlign: "center",
  headerAlign: "center",
  border: true,
  expand: false,
  stripe: false,
  showHeader: true,
  // align: 'center',
  index: false,
  selection: true,
  menu: true,
  page: true,
  addBtn: false,
  editBtn: false,
  delBtn: false,
  columnBtn: false,
  //viewBtn: true,
  menuWidth: "200",
  labelWidth: "150",
  defaultSort: {
    prop: "createTime",
    order: "descending",
  },
  column: [
    {
      label: "产品名称",
      prop: "name",
      type: "input",
      search: true,
      span: 13,
      placeholder: "请选择客户端类型",
    },
    //rebate返利金额
    /*  {
       label: "返利金额",
       prop: "rebate",
       type: "input",
       span: 13,
       placeholder: "请输入返利金额",
     }, */
    {
      label: "产品价格",
      prop: "price",
      type: "input",
      span: 13,
      placeholder: "请输入产品价格",
    },
    {
      label: "分组",
      prop: "costGrouping",
      type: "input",
      span: 13,
      placeholder: "请输入分组",
    },
    {
      label: "材料类型",
      prop: "materialType",
      type: "select",
      span: 13,
      dicData: [
        { label: "其它", value: 0 },
        { label: "刚性", value: 1 },
        { label: "柔性", value: 2 },
      ],
      placeholder: "请选择材料类型",
    },
    {
      label: "最低平方用料（元/平方）",
      prop: "areaCost",
      type: "input",
      span: 13,
      placeholder: "请输入最低平方用料",
    },
    {
      label: "平方用料上限（元/平方）",
      prop: "areaCostCap",
      type: "input",
      span: 13,
      placeholder: "请输入平方用料上限",
    },
    // 创建时间
    {
      label: "创建时间",
      prop: "createTime",
      type: "datetime",
      valueFormat: "timestamp",
      format: "yyyy-MM-dd HH:mm:ss",
      // search: true,
      addVisdiplay: false,
      editVisdiplay: false,
    },
    {
      label: "创建人",
      prop: "createBy",
      type: "input",
      search: true,
      addVisdiplay: false,
      editVisdiplay: false,
      width: "110",
    },
    {
      label: "更新时间",
      prop: "updateTime",
      type: "datetime",
      // search: true,
      valueFormat: "timestamp",
      format: "yyyy-MM-dd HH:mm:ss",
      addVisdiplay: false,
      editVisdiplay: false,
    },

    {
      label: "更新人",
      prop: "updateBy",
      type: "input",
      search: true,
      addVisdiplay: false,
      editVisdiplay: false,
      width: "110",
    },
  ],
};
